import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicCircadianRhythmDiagramContent } from "./CardiometabolicCircadianRhythmDiagram";
import { CardiometabolicCircadianRhythmKeyContent } from "./CardiometabolicCircadianRhythmKey";

const SvgCardiometabolicCircadianRhythmDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1326, 1542)}
      viewBox={diagramOnly ? "0 142 1024 1326" : "0 0 1024 1542"}
    >
      <g id="cardiometabolic-circadianrhythm-diagram+key" clipPath="url(#clip0_18295_235669)">
        <rect width={1024} height={diagramOnly ? 1326 : 1542} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicCircadianRhythmKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <CardiometabolicCircadianRhythmDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18295_235669">
          <rect width={1024} height={1542} fill="white" />
        </clipPath>
        <clipPath id="clip1_18295_235669">
          <rect width={1024} height={1326} fill="white" transform="translate(0 142)" />
        </clipPath>
        <clipPath id="clip2_18295_235669">
          <rect
            width={32.2315}
            height={32.2315}
            fill="white"
            transform="translate(127.846 237.597)"
          />
        </clipPath>
        <clipPath id="clip3_18295_235669">
          <rect
            width={32.2304}
            height={32.2832}
            fill="white"
            transform="translate(922.135 242.235)"
          />
        </clipPath>
        <clipPath id="clip4_18295_235669">
          <rect
            width={17.4892}
            height={27.637}
            fill="white"
            transform="translate(72.3086 319.812)"
          />
        </clipPath>
        <clipPath id="clip5_18295_235669">
          <rect
            width={33.8634}
            height={23.3932}
            fill="white"
            transform="translate(64.123 358.116)"
          />
        </clipPath>
        <clipPath id="clip6_18295_235669">
          <rect width={36.4448} height={25.32} fill="white" transform="translate(62.834 283.361)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicCircadianRhythmDiagramKey;
